import { DefaultApiHead } from '../fetchEnv';
import { getLoginToken } from '../../utils/LoginToken';

export const getPubData = () => {
  return encodeURIComponent(JSON.stringify({ c: 'H5', b: 'MERCHANT-WEBSITE', id: '102', t: new Date() }));
};

export default {
  fieldconfigQuery: {
    url: '/website/fieldconfig/query',
  },
  fieldconfigEdit: {
    url: '/website/fieldconfig/edit',
  },
  dealListQuery: {
    url: 'website/trade/manage/data/query',
  },
  dealDetails: {
    url: 'website/trade/manage/data/detail',
  },
  merchantstlQuery: {
    url: '/website/merchantstl/query',
  },
  merchantstlDetails: {
    url: '/website/merchantstl/detail',
  },
  applyEnter: {
    url: '/website/refund/manage/apply/entry',
  },
  applySubmit: {
    url: '/website/refund/manage/apply/submit',
  },
  applyQuery: {
    url: '/website/refund/manage/apply/query',
  },
  applyAudit: {
    url: '/website/refund/manage/apply/audit',
  },
  batchapplyUpload: {
    url: '/website/refund/manage/batchapply/upload',
    isFormData: true,
  },
  batchapplyQuery: {
    url: '/website/refund/manage/batchapply/query',
  },
  enumsQuery: {
    url: '/website/common/enums',
  },
  batchapplyFileDownload: {
    url: '/website/download/download/batchRefundApply',
    method: 'get',
  },
  downloadUrl: {
    url: '/website/download/download/batchRefundApply',
    isUrl: true,
  },
  UploadUrl: {
    url: `/website/refund/manage/batchapply/upload?authorization=${getLoginToken()}&pubData=${getPubData()}`,
    isUrl: true,
  },
};



// WEBPACK FOOTER //
// ./src/service/apiConfig/apiDealCenter.js